/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientEntity } from './ClientEntity';
import {
    ClientEntityFromJSON,
    ClientEntityFromJSONTyped,
    ClientEntityToJSON,
} from './ClientEntity';

/**
 * Payload of enumerated client organizations
 * @export
 * @interface ClientEntityEnumeration
 */
export interface ClientEntityEnumeration {
    /**
     * 
     * @type {Array<ClientEntity>}
     * @memberof ClientEntityEnumeration
     */
    items: Array<ClientEntity>;
}

/**
 * Check if a given object implements the ClientEntityEnumeration interface.
 */
export function instanceOfClientEntityEnumeration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function ClientEntityEnumerationFromJSON(json: any): ClientEntityEnumeration {
    return ClientEntityEnumerationFromJSONTyped(json, false);
}

export function ClientEntityEnumerationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientEntityEnumeration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ClientEntityFromJSON)),
    };
}

export function ClientEntityEnumerationToJSON(value?: ClientEntityEnumeration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ClientEntityToJSON)),
    };
}

